import { render, staticRenderFns } from "./no-wrap.vue?vue&type=template&id=dab4c21c&"
var script = {}
import style0 from "./no-wrap.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports